















































import Vue from "vue";
import { Controllers } from "@infoland/iprova-api";
import Toolbar from "../../components/toolbar/Toolbar.vue";
import storeHelper from "../../store/store-helper";
import { Team, Member, Membership } from "@/teams";
import Utils from "@/utils";
import TeamMembers from "./TeamMembers.vue";
import TeamProperties from "./TeamProperties.vue";
import { loadNotificationsForTeamAsync, loadTasksForTeamAsync, Task } from "@/tasks";
import TasksTab from "../../components/tasks/TasksTab.vue";
import NotificationsTab from "../../components/tasks/NotificationsTab.vue";

export default Vue.extend({
    name: "Team",
    components: { Toolbar, TeamMembers, TeamProperties, TasksTab, NotificationsTab },
    props: {
        teamId: String,
        tab: { default: "tasks" }
    },
    data: () => {
        return {
            members: [] as Member[],
            membersLoaded: false,
            tasks: [] as Task[],
            tasksLoaded: false,
            notifications: [] as Task[],
            notificationsLoaded: false
        };
    },
    mounted() {},
    computed: {
        team: function () {
            return storeHelper.teamsStore.teams.find(t => t.team_id == this.teamId);
        }
    },
    watch: {
        tab: {
            immediate: true,
            handler: function (newTab: string) {
                const hasPanels = newTab == "properties" || newTab == "members";
                this.$emit("has-panels", hasPanels);
            }
        },
        teamId: {
            immediate: true,
            async handler(newValue: string): Promise<any> {
                this.notificationsLoaded = false;
                this.membersLoaded = false;
                //this.tasksLoaded  is updaten in the loadTasksAsync function

                //run load stuff parallel
                const tasksPromise = this.loadTasksAsync();

                const teamPromise = Controllers.GenericController.getAsync<Member[]>(`/teams/${this.teamId}/members`).then(members => {
                    this.members = members;
                    this.membersLoaded = true;
                });

                const notificationsPromise = loadNotificationsForTeamAsync(newValue).then(notifications => {
                    this.notifications = notifications;
                    this.notificationsLoaded = true;
                });

                return Promise.all([teamPromise, tasksPromise, notificationsPromise]);
            }
        },
        team: {
            deep: true,
            async handler(newValue: Team) {
                //team route changed
                //set site title
                storeHelper.siteStore.title = newValue?.name;
                this.members = await Controllers.GenericController.getAsync<Member[]>(`/teams/${this.teamId}/members`);
                document.title = Utils.getPageTitle(this.team.name, "after");
            }
        },
        "team.name": {
            immediate: true,
            handler(newName: string) {
                //set site title
                storeHelper.siteStore.title = newName;
            }
        }
    },
    methods: {
        async loadTasksAsync(): Promise<void> {
            this.tasksLoaded = false;
            this.tasks = await loadTasksForTeamAsync(this.teamId);
            this.tasksLoaded = true;
        }
    }
});
